import { FC } from 'react';

type Props = {
	className?: string;
};

const Calendar01Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M14.799 2V3.59997M5.19922 2V3.59997'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.39764 14.0002L8.39763 11.078C8.39763 10.9247 8.28824 10.8003 8.15331 10.8003H7.59766M11.3013 14.0002L12.3849 11.0796C12.4356 10.9431 12.3278 10.8003 12.1741 10.8003H10.7976'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M2.39844 10.1947C2.39844 6.70897 2.39844 4.96607 3.40011 3.88318C4.40179 2.80029 6.01396 2.80029 9.2383 2.80029H10.7583C13.9826 2.80029 15.5948 2.80029 16.5965 3.88318C17.5981 4.96607 17.5981 6.70897 17.5981 10.1947V10.6056C17.5981 14.0913 17.5981 15.8342 16.5965 16.9171C15.5948 18 13.9826 18 10.7583 18H9.2383C6.01396 18 4.40179 18 3.40011 16.9171C2.39844 15.8342 2.39844 14.0913 2.39844 10.6056V10.1947Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.19922 6.7998H14.799'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Calendar01Icon;
